import * as React from 'react'

import { Box, Checkbox } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: (value: string) => void
  onClick: () => void
  width?: string
  customFieldId: number
}

const CustomFieldText = ({
  bulkEditForm,
  onChange,
  onClick,
  isChecked,
  width,
  customFieldId,
}: Props) => {
  const [value, setValue] = React.useState(bulkEditForm.get(customFieldId.toString())?.value)

  const onHandleBlur = () => {
    bulkEditForm.setValues({
      [customFieldId]: value,
    })
    onChange(value)
  }

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width }}
    >
      <Box flexNoShrink>
        <Checkbox checked={isChecked} onChange={onClick} />
      </Box>
      <TextField onChange={setValue} value={value} onBlur={onHandleBlur} />
    </Box>
  )
}

export default CustomFieldText
